import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizerBypassHtml',
  standalone: true,
})
export class SanitizerBypassHtmlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(value: string): SafeHtml {
    if (!value) {
      return value;
    }

    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
